import { render } from "./AppCustomTable.vue?vue&type=template&id=2d159d46&scoped=true"
import script from "./AppCustomTable.vue?vue&type=script&lang=js"
export * from "./AppCustomTable.vue?vue&type=script&lang=js"

import "./AppCustomTable.vue?vue&type=style&index=0&id=2d159d46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d159d46"]])

export default __exports__